import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { shouldAddGoogleContactsSyncStep } from '../../google-contacts-sync/googleContactsSyncUtils';
import { Step } from '../../views/Step';
export const BranchGoogleContactsSync = {
  name: 'BranchGoogleContactsSync',
  stateCheck: state => {
    return shouldAddGoogleContactsSyncStep(state);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const nextSteps = dispatch(FlowStateManager.replaceStep(Step.CrmExperienceLevel, Step.GoogleContactsSync, Step.CrmExperienceLevel));
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.Industry,
  afterData: null,
  afterStep: null
};